(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      if (section.dataset.selectionReady) return;
      section.dataset.selectionReady = 'true';
      var json = section.querySelector('[id^="ProductJson-"]') || document.getElementById('ProductJson-' + section.dataset.sectionId);
      if (!json) return;
      var product = JSON.parse(json.textContent);
      var form = section.querySelector('[data-product-form]');
      var master = form && form.querySelector('select[name="id"]');
      if (!master) return;
      var $ = window.jQuery;
      var main = section.querySelector('.fl-product-media-slider');
      var side = section.querySelector('.fl-product-media-sidebar');
      var mobile = section.querySelector('.media_slider_area');
      [main,mobile].forEach(function (gallery) {
        $(gallery).on('beforeChange.auditMedia', function (event, slick, current) {
          slick.$slides.eq(current).find('[data-product-single-media-wrapper]').addBack('[data-product-single-media-wrapper]').each(function () {this.dispatchEvent(new CustomEvent('mediaHidden'));});
        });
      });
      // Slick 1.9 getLeft offsets short vertical navs on setPosition even
      // when every thumbnail fits. Correct this instance's calculation, not
      // the CSS transform: long strips retain Slick's normal scrolling.
      if (side) $(side).on('init.auditThumbnailPosition', function (event, slick) {
        var getLeft = slick.getLeft;
        slick.getLeft = function (index) {
          if (this.options.vertical && !this.options.centerMode &&
              this.slideCount <= this.options.slidesToShow) return 0;
          return getLeft.call(this, index);
        };
        // Browser focus/scroll-into-view can also scroll the hidden-overflow
        // list. Slick owns this strip's position through its track transform.
        if (slick.$list && slick.$list[0]) slick.$list[0].addEventListener('scroll', function () {
          if (this.scrollTop) this.scrollTop = 0;
        }, {passive:true});
        // Finite navigation tracks stop at the final full window. Slick's
        // active classes must describe that window, not start at the last image.
        var setSlideClasses = slick.setSlideClasses;
        slick.setSlideClasses = function (index) {
          setSlideClasses.call(this, index);
          if (!this.options.vertical || this.options.infinite || this.options.centerMode) return;
          var start = Math.max(0, Math.min(index, this.slideCount - this.options.slidesToShow));
          this.$slides.removeClass('slick-active').attr('aria-hidden', 'true')
            .slice(start, start + this.options.slidesToShow)
            .addClass('slick-active').attr('aria-hidden', 'false');
        };
        // initADA removes tabindex from the selected DIV and drops keyboard
        // focus. Restore only focus it just removed, never steal it from a shade.
        var initADA = slick.initADA;
        slick.initADA = function () {
          var focused = document.activeElement;
          var wasThumbnail = this.$slides.toArray().indexOf(focused) !== -1;
          var result = initADA.call(this);
          if (wasThumbnail && focused.isConnected && focused.classList.contains('slick-active') &&
              document.activeElement === document.body) {
            focused.setAttribute('tabindex', '0');
            focused.focus({preventScroll:true});
          }
          return result;
        };
      });
      if (main && !$(main).hasClass('slick-initialized')) {
        $(main).slick({slidesToShow:1, slidesToScroll:1, arrows:false, fade:true, dots:false, infinite:false, asNavFor:side});
        $(side).slick({vertical:true, verticalSwiping:true, slidesToShow:5, slidesToScroll:1, arrows:true, infinite:false, asNavFor:main, dots:false, focusOnSelect:true});
        $(mobile).slick({dots:true, arrows:true, infinite:false, speed:300, slidesToShow:1, slidesToScroll:1});
      }
      if (side) side.addEventListener('keydown', function (event) {
        var slide=event.target.closest('.slick-slide');
        if (!slide || event.target!==slide || (event.key!=='Enter' && event.key!==' ')) return;
        event.preventDefault();
        $(main).slick('slickGoTo',Number(slide.getAttribute('data-slick-index')));
      });
      // Exact existing media IDs verified against the product's displayed image names.
      // Missing shade photos fall back to the neutral bottle image, never another shade.
      var oxygenMedia = {
        'B1-Swatch-Pearl':24936571142327, 'B2-Swatch-Ivory':24936571175095,
        'B3-Swatch-Taupe':24936571207863, 'B4-Swatch-Walnut':24936571240631,
        'B5-Swatch-Coco':24936571273399, 'B6-Swatch-Ebony':24936571306167
      };
      function sync(variant) {
        form.querySelectorAll('[data-shade-option]').forEach(function (group) {
          var option = form.querySelector('.single-option-selector[data-index="' + group.dataset.shadeOption + '"]');
          group.querySelectorAll('input[type="radio"]').forEach(function (radio) {
            radio.checked = radio.value === option.value;
            radio.closest('.shade-item').classList.toggle('active', radio.checked);
          });
        });
        var note = section.querySelector('[data-media-note]');
        var id = variant && variant.featured_media && variant.featured_media.id;
        var missing = false;
        if (variant && product.handle === 'oxygenetix-oxygenating-foundation') {
          id = oxygenMedia[variant.option1];
          missing = !id;
          id = id || 24997055594679;
        }
        if (note) {
          note.hidden = !missing;
          note.textContent = missing ? 'A shade-specific product photo is not available for this selection. Showing the general product image.' : '';
        }
        if (!id) return;
        [main,mobile].forEach(function (gallery) {
          if (!gallery || !$(gallery).hasClass('slick-initialized')) return;
          var slick = $(gallery).slick('getSlick');
          var index = Array.from(slick.$slides).findIndex(function (slide) { var media = slide.matches('[data-media-id]') ? slide : slide.querySelector('[data-media-id]'); return media && media.dataset.mediaId === section.dataset.sectionId + '-' + id; });
          if (index >= 0) $(gallery).slick('slickGoTo', index, true);
        });
      }
      form.addEventListener('change', function (event) {
        var radio = event.target;
        if (!radio.matches('.shade-filter-checkbox')) return;
        var group = radio.closest('[data-shade-option]');
        var option = form.querySelector('.single-option-selector[data-index="' + group.dataset.shadeOption + '"]');
        option.value = radio.value;
        option.dispatchEvent(new Event('change', {bubbles:true}));
      });
      form.addEventListener('click', function (event) {
        var button = event.target.closest('[data-shade-disclosure]');
        if (!button) return;
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
      });
      section.addEventListener('variantChange', function (event) { sync(event.detail.variant); });
      sync(product.variants.find(function (v) { return String(v.id) === master.value; }));
    });
  }
  if (!window.theme) window.theme = {};
  if (window.theme.productSelectionLoaded) return;
  window.theme.productSelectionLoaded = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
